import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import {
  Container,
  Typography,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Collapse,
} from "@mui/material";
import TBAdminTopNav from "./TBAdminTopNav";
import OrgRegistration from "./OrgRegistration"; 

const OrganizationsList = () => {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false); 

  useEffect(() => {
    const q = query(
      collection(db, "organizations"),
      orderBy("createdAt", "desc")
    );
    const unsubscribe = onSnapshot(
      q,
      (querySnapshot) => {
        const orgs = [];
        querySnapshot.forEach((doc) => {
          orgs.push({ id: doc.id, ...doc.data() });
        });
        setOrganizations(orgs);
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching organizations:", error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp.toDate();
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <TBAdminTopNav />

      <Typography variant="h4" gutterBottom>
        Registered Organizations
      </Typography>

      <Button
        variant="contained"
        color="primary"
        sx={{ mb: 3 }}
        onClick={() => setShowForm((prev) => !prev)}
      >
        {showForm ? "Hide Form" : "Register New Organization"}
      </Button>

      {/* ✅ Show registration form inline */}
      <Collapse in={showForm}>
        <OrgRegistration />
      </Collapse>

      {loading ? (
        <CircularProgress />
      ) : organizations.length === 0 ? (
        <Typography>No organizations registered yet.</Typography>
      ) : (
        <TableContainer component={Paper} sx={{ mt: 4 }}>
          <Table aria-label="organizations table">
            <TableHead>
              <TableRow>
                <TableCell>Organization Name</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Registered On</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {organizations.map((org) => (
                <TableRow key={org.id}>
                  <TableCell>{org.name}</TableCell>
                  <TableCell>{org.description || "-"}</TableCell>
                  <TableCell>{formatDate(org.createdAt)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};

export default OrganizationsList;
